import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import {
  giftNoteItemChips,
  PREVIEW_GIFT_NOTES,
  PREVIEW_MAX_ENTRIES,
  resolveAddCard,
} from '../../multi-shipment-example.model';
import { EntryCardChip, EntryCardRow } from '../entry-card-preview/entry-card-preview.component';

interface GiftNoteCardView {
  number: number;
  title: string;
  chips: EntryCardChip[];
  rows: EntryCardRow[];
}

@Component({
  selector: 'multi-shipment-gift-notes-preview',
  templateUrl: './gift-notes-preview.component.html',
  styleUrls: ['./gift-notes-preview.component.scss'],
  standalone: false,
})
export class GiftNotesPreviewComponent implements OnChanges {
  @Input() giftNotesBlock: MultiShipmentExtension.GiftNotesBlock;
  @Input() giftNoteCount = 0;

  @Output() giftNoteAdded = new EventEmitter<void>();
  @Output() giftNoteRemoved = new EventEmitter<void>();

  notes: GiftNoteCardView[] = [];
  addCard: MultiShipmentExtension.ActionCard;
  canAddGiftNote = false;

  ngOnChanges(): void {
    this.notes = PREVIEW_GIFT_NOTES.slice(0, this.giftNoteCount).map((note) => ({
      number: note.number,
      title: `To ${note.to}`,
      chips: giftNoteItemChips(note),
      rows: [{ label: 'Gift note', value: note.message }],
    }));
    this.canAddGiftNote = this.giftNoteCount < PREVIEW_MAX_ENTRIES;
    this.addCard = resolveAddCard(
      this.giftNotesBlock?.addGiftNoteCard,
      this.giftNotesBlock?.addAnotherGiftNoteCard,
      this.giftNoteCount,
    );
  }
}
